import AOS from 'aos';

const Animations = () => {
    AOS.init({
        offset: 200,
    });
}
Animations();